import { paths } from "@/App";
import { useUser } from "@clerk/react";
import { Navigate, Outlet } from "react-router";

export default function AuthGuard() {
  const { isSignedIn, isLoaded } = useUser();

  if (!isLoaded) {
    return null;
  }

  if (!isSignedIn) {
    return <Navigate to={paths.signIn()} />;
  }

  return <Outlet />;
}
